import styled from 'styled-components';
import media from 'styled-media-query';
import { flexBox, fontSize } from '../../shared/styles/mixins';

export const Header = styled.section`
  ${flexBox('row wrap')}  
  span {
    ${fontSize(20)};
    font-weight: 600;
  }
  ${media.greaterThan('medium')`
    justify-content: flex-start;
    margin-bottom: 30px;
    position: relative;
    width: 50%;
    border-bottom: 1px solid #fe3c49;  
    i {
      cursor: pointer;
      font-size: 20px;
      position: absolute;
      left: -29px;
      color: rgba(0 0 0 .65);
    }
  `};
  ${media.lessThan('768px')`
    padding: 0 16px;
    height: 56px;
    right: 0;
    left: 0;
    position: absolute;
    top: 0;
    background: #fe3c49;
    z-index: 11;
    justify-content: space-between;
    span {
      color: white;
    }
    i {
      color: white;
    }
  `}
`;

export const ProceduresList = styled.ul`
  margin: 36px 0;
  li {
    list-style: inside;
    margin-bottom: 16px;
  }
  ${media.greaterThan('medium')`
    ${flexBox('row wrap', 'space-between')}
    li {
      width: calc(50% - 10px);
    }
  `};
`;

export const ProcedureItem = styled.li`
  text-decoration: underline;
  cursor: pointer;
`;

